import { IGiftCardsToBuyDenominationItem } from '@core/interfaces/cart/giftcards-to-buy-denomination-item.interface';
import { IGiftCardsToBuyDenomination } from '@core/interfaces/cart/giftcards-to-buy-denomination.interface';
import { Currency, parseArray } from '@interticket/core';
import { GiftCardsToBuyDenominationItem } from './giftcards-to-buy-denomination-item.model';

export class GiftCardsToBuyDenomination implements IGiftCardsToBuyDenomination {

  readonly count: number;
  readonly totalPrice: number;
  readonly unitPrice: number;
  readonly currency: Currency;
  readonly vat: string;
  readonly items: GiftCardsToBuyDenominationItem[];

  constructor(iGiftCardsToBuyDenomination: IGiftCardsToBuyDenomination) {
    this.count = iGiftCardsToBuyDenomination.count;
    this.totalPrice = iGiftCardsToBuyDenomination.totalPrice;
    this.unitPrice = iGiftCardsToBuyDenomination.unitPrice;
    this.currency = iGiftCardsToBuyDenomination.currency;
    this.vat = iGiftCardsToBuyDenomination.vat;
    this.items = parseArray<IGiftCardsToBuyDenominationItem, GiftCardsToBuyDenominationItem>(iGiftCardsToBuyDenomination.items, GiftCardsToBuyDenominationItem);
  }

}
